var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('splide',{attrs:{"options":_vm.options}},_vm._l((_vm.pictures),function(picture,index){return _c('splide-slide',{key:index,attrs:{"data":picture.path}},[_c('img',{attrs:{"src":picture.path}})])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }